// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10y-S","location":"Header_location__2hZ6X"};